import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const Privacy = () => (
  <div className="about-page">
    <header className="about-header">
      <p className="about-kicker">Legal</p>
      <h1 className="about-title">Privacy Policy</h1>
      <p className="about-tagline">
        How ScoreClash handles your data. Last updated 2 October 2026.
      </p>
    </header>

    <section className="about-section">
      <h2>Who we are</h2>
      <p>
        ScoreClash (<a href="https://scoreclash.app">scoreclash.app</a>) is a football prediction
        game. Contact:{' '}
        <a href="https://x.com/ScoreClash" target="_blank" rel="noopener noreferrer">
          @ScoreClash on X
        </a>
        .
      </p>
    </section>

    <section className="about-section">
      <h2>What we collect</h2>
      <ul className="about-spark">
        <li>
          <strong>Account</strong> — email, username, password (hashed), and optional profile settings
          (for example league preference or display icons).
        </li>
        <li>
          <strong>Gameplay</strong> — picks, plays, standings, league memberships, and related game
          activity.
        </li>
        <li>
          <strong>Payments</strong> — coin purchases are processed by Stripe. We store purchase records
          and balances; card details are handled by Stripe, not by us.
        </li>
        <li>
          <strong>Technical</strong> — basic logs and security signals (for example bot checks on
          signup) needed to run and protect the service.
        </li>
      </ul>
    </section>

    <section className="about-section">
      <h2>How we use it</h2>
      <ul className="about-spark">
        <li>Provide the game, standings, leagues, and store.</li>
        <li>Send essential account emails (for example email verification).</li>
        <li>Operate ScoreClash marketing channels, including automated YouTube Shorts from public game
          outcomes (not from your personal YouTube account).</li>
        <li>Prevent abuse and keep the service reliable.</li>
      </ul>
    </section>

    <section className="about-section">
      <h2>Sharing</h2>
      <p>
        We do not sell your personal data. We use processors such as AWS (hosting), Stripe (payments),
        and email delivery to run ScoreClash. Public profile information you choose to show (for
        example username and standings) is visible to other players.
      </p>
    </section>

    <section className="about-section">
      <h2>Retention &amp; your choices</h2>
      <p>
        We keep account and gameplay data while your account is active and as needed to operate the
        game. You can ask us to correct or delete account data by contacting{' '}
        <a href="https://x.com/ScoreClash" target="_blank" rel="noopener noreferrer">
          @ScoreClash
        </a>
        .
      </p>
    </section>

    <section className="about-section">
      <h2>Changes</h2>
      <p>
        We may update this policy; the date above will change when we do. Continued use of ScoreClash
        after an update means you accept the revised policy.
      </p>
      <Link to="/" className="about-cta sc-btn sc-btn-primary">
        Back to ScoreClash
      </Link>
    </section>
  </div>
);

export default Privacy;
